import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WebdokuService } from '../web-doku/webdoku.service';
import { DocumentService } from '../shared/services/document.service';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { DocumentDetailResolved } from '../shared/models/document-detail-resolved';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class DocumentDetailResolver {
  private webDokuService = inject(WebdokuService);
  private documentService = inject(DocumentService);
  protected title = inject(Title);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<DocumentDetailResolved> {
    const wd = route.paramMap.get('wd') ?? '';
    const docid = route.paramMap.get('docid') ?? '';
    console.log(`document resolve for ${docid}`)

    return this.webDokuService.selectWebDoku(wd).pipe(
      switchMap((wdSelectOk) => this.getDocument(wdSelectOk, docid))
    );
  }

  getDocument(selectWdOk: boolean, docid: string): Observable<DocumentDetailResolved> {
    if (!selectWdOk) {
      return of({
        documentDetail: undefined,
        docId: docid,
        error: new Error(`wd not selectable`)
      });
    }
    return this.documentService.getDocument(docid)
      .pipe(
        map(documentDetail => ({ documentDetail: documentDetail, docId: docid })),
        tap(document => this.title.setTitle(document.documentDetail.text)),
        catchError((err) => of({
          documentDetail: undefined,
          docId: docid,
          error: err
        }))
      );
  }
}
